export default __webpack_public_path__ + "assets/e6b64f.svg";